import { Search } from '@/DTOS/Report/Search';
import request from '../../utils/request';

const ReportPMFinancialService = {
    collectionPMFinancial: (search: Search) => {
        return request('/report/collectionPMFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },

    paymentPMFinancial: (search: Search) => {
        return request('/report/paymentPMFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },

    balancePMFinancial: (search: Search) => {
        return request('/report/balancePMFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },
};

export default ReportPMFinancialService;
